import { CRUDServiceBase } from '@lib/Http'
import { ECategoryType, EMediaStatus, EMediaType, ICategory, ICategoryDetail, IMedia } from '@shared/Types'
import Graphql from '@coreprj/graphql'

export type TMedia = Graphql.QMediaStore.TMedia
export type TCategory = Graphql.QMediaStore.TMOCategory
type TMediaFilterParams = Graphql.QMediaStore.TMediaFilterParams
type TCategoryGraphQlResult = Graphql.TGraphQlResult<TCategory>
type TAllResult = {
  media?: TMedia
  categories?: TCategoryGraphQlResult
}

class CategoryDetailServiceBase extends CRUDServiceBase<ICategoryDetail, string> {
  constructor(categoryId: string) {
    super(`/api/v1/user/Category/${categoryId}/Detail`)
  }
}
class CategoryDetailGraphQLService {
  GraphQLAll = async (params: TMediaFilterParams, signal?: AbortSignal): Promise<TAllResult> => {
    const res = await Graphql.MediaStore.Query(Graphql.QMediaStore.CategoriesAndCategoryDetailByMediaId(params), { signal, delay: 200 })
    const dataResult: TAllResult = {
      media: res.mediaStore.media as TMedia,
      categories: res.mediaStore.categories as TCategoryGraphQlResult
    }
    return dataResult
  }
}
export const CategoryDetailService = new CategoryDetailGraphQLService()
export const CreateCategoryDetailService = (categoryId: string) => new CategoryDetailServiceBase(categoryId)

class CategoryDetailMappingBase {
  media = (item: TMedia): IMedia => ({
    Id: item.id,
    UserCreatedId: item.userCreatedId,
    Name: item.name ?? '',
    Description: item.description ?? '',
    Duration: item.duration,
    Size: item.size,
    Extension: item.extension ?? '',
    ResourceId: item.resourceId ?? '',
    Type: item.type as EMediaType,
    CategoryNames: item.categoryDetails?.map((x) => x?.category?.name) as string[],
    Status: item.status as EMediaStatus,
    Reason: item.reason ?? '',
    DateCreated: item.dateCreated
  })

  categoryDetails = (value?: TMedia): ICategoryDetail[] => {
    if (!value) return []
    const list = value.categoryDetails ?? []
    const temp = list.reduce<ICategoryDetail[]>((a, b) => {
      if (b) {
        a.push({
          Id: b.id,
          CategoryId: b.categoryId,
          Category: b.category ? this.category(b.category as TCategory) : undefined,
          MediaId: b.mediaId,
          DateCreated: b.dateCreated
        })
      }
      return a
    }, [])
    return temp
  }

  category = (item: TCategory): ICategory => ({
    Id: item.id,
    Name: item.name ?? '',
    Description: item.description ?? '',
    ImageUri: item.imageUri ?? '',
    Type: item.type as ECategoryType,
    DateCreated: item.dateCreated
  })

  categories = (items: TCategory[] = []): ICategory[] => items.map<ICategory>(this.category)
}
export const CategoryDetailMapping = new CategoryDetailMappingBase()
